export const validatePlanta = (data) => {
  const errors = {};

  // Validar nombre
  if (!data.nombre || data.nombre.trim() === '') {
    errors.nombre = 'El nombre es requerido';
  } else if (data.nombre.length < 2) {
    errors.nombre = 'El nombre debe tener al menos 2 caracteres';
  } else if (data.nombre.length > 100) {
    errors.nombre = 'El nombre no puede exceder 100 caracteres';
  }

  // Validar ciudad
  if (!data.ciudad || data.ciudad.trim() === '') {
    errors.ciudad = 'La ciudad es requerida';
  } else if (data.ciudad.length < 2) {
    errors.ciudad = 'La ciudad debe tener al menos 2 caracteres';
  } else if (data.ciudad.length > 50) {
    errors.ciudad = 'La ciudad no puede exceder 50 caracteres';
  }

  // Validar dirección
  if (!data.direccion || data.direccion.trim() === '') {
    errors.direccion = 'La dirección es requerida';
  } else if (data.direccion.length < 5) {
    errors.direccion = 'La dirección debe tener al menos 5 caracteres';
  } else if (data.direccion.length > 200) {
    errors.direccion = 'La dirección no puede exceder 200 caracteres';
  }

  // Validar teléfono
  if (!data.telefono || data.telefono.trim() === '') {
    errors.telefono = 'El teléfono es requerido';
  } else if (!/^[\d\s\-\+\(\)]+$/.test(data.telefono)) {
    errors.telefono = 'El teléfono debe contener solo números, espacios, guiones, paréntesis o signo +';
  } else if (data.telefono.length < 7) {
    errors.telefono = 'El teléfono debe tener al menos 7 caracteres';
  } else if (data.telefono.length > 20) {
    errors.telefono = 'El teléfono no puede exceder 20 caracteres';
  }

  // Validar encargado
  if (!data.encargado || data.encargado.trim() === '') {
    errors.encargado = 'El encargado es requerido';
  } else if (data.encargado.length < 2) {
    errors.encargado = 'El nombre del encargado debe tener al menos 2 caracteres';
  } else if (data.encargado.length > 100) {
    errors.encargado = 'El nombre del encargado no puede exceder 100 caracteres';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};
